export const fetchNotificationsKey = 'fetch-notifications';

export const dropdownOptsClassNames = [
  'text-accent-large',
  'hover:bg-gray-100',
  'cursor-pointer',
  'border-b',
  'border-neutral-lighter',
  'border-b-solid',
  'text-black',
  'font-medium',
  'p-4',
  'text-left',
];
